import { windowProps } from "./constants";

export type Dictionary = {
    countrySelector: string,
    externalSitesTitle: string,
    languageSelector: string,
    dstvLogin: string,
    dstvForMe: string,
    dstvForBusiness: string,
    openMenu: string,
    searchNow: string,
    searchPlaceholder: string,
    signIn: string,
    signOut: string,
    browseSites: string,
    appBannerText: string,
    appBannerCTA: string,
}

const DefaultDictionary: Dictionary = {
    externalSitesTitle: "Quickly jump to one of the following channels",
    countrySelector: "Country Selector",
    signIn: "Sign in",
    dstvLogin: "Login to DStv",
    dstvForMe: "For me",
    dstvForBusiness: "For my business",
    signOut: "Sign out",
    openMenu: "OPEN MENU",
    searchPlaceholder: "What can we help you find?",
    searchNow: "Search now",
    languageSelector: "Select Language",
    browseSites: "Browse Our Channel Sites",
    appBannerText: "Unlock New Possibilities with our MyDStv App",
    appBannerCTA: "Download the app",

};

export type LanguageDictionary = {
    en: string,
    pt: string
}

export const englishLanguageDictionary: LanguageDictionary = {
    en: "English",
    pt: "Portuguese"
}

const portugueseLanguageDictionary: LanguageDictionary = {
    en: "Inglês",
    pt: "Português"
}

class DictionaryHelper {
    static get dictionary() {
        return windowProps?.dictionary as Dictionary ?? DefaultDictionary;
    }

    static getLanguageDictionary(culture: string) {
        switch (culture) {
            case "pt":
                return portugueseLanguageDictionary;

            default:
                return englishLanguageDictionary;
        }
    }
}

export default DictionaryHelper